import ImageLazy from '@Web/Src/Components/Image/Lazy/index.jsx';

const SimpleSwiper = ({ items = [], className = '' }) => {
    return (
        <div className='relative h-max w-full overflow-hidden'>
            <div className='slider-animated flex will-change-transform'>
                {items.concat(items).map((item, index) => (
                    <ImageLazy
                        width={100}
                        key={index}
                        className={`block flex-shrink-0 ${className}`}
                        src={item.img}
                        lowSrc={item.imgLow}
                        alt={item.alt || 'Certificate'}
                    />
                ))}
            </div>
        </div>
    );
};

export default SimpleSwiper;
